import { get } from 'store/http/httpAction';
import {
  SET_REPORT_FOLDERS,
  SET_DASHBOARD_FOLDERS,
  RESET_REPORTLIST_STORE
} from './actionTypes';

const setReportFolders = (rawData, type) => ({
  type: SET_REPORT_FOLDERS,
  payload: { rawData, type }
});

const setDashboardFolders = (rawData, type) => ({
  type: SET_DASHBOARD_FOLDERS,
  payload: { rawData, type }
});

export const tryFetchReportFolders = () => dispatch =>
  get('/admin/report_folder/me', {}, dispatch).then(data => {
    dispatch(setReportFolders(data, 'report'));
  });

export const tryFetchDashboardFolders = () => dispatch =>
  get('/admin/dashboard_folder/me', {}, dispatch).then(data => {
    dispatch(setDashboardFolders(data, 'dashboard'));
  });

export const resetStore = () => ({
  type: RESET_REPORTLIST_STORE
});



// WEBPACK FOOTER //
// ./src/views/ReportList/flow/actions.js